export default __webpack_public_path__ + "static/media/wallet-card-theme4.9735c5f6.svg";